/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FunctionalSkillResource } from './';
import {
    FunctionalSkillResourceFromJSON,
    FunctionalSkillResourceFromJSONTyped,
    FunctionalSkillResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FunctionalScopeResource
 */
export interface FunctionalScopeResource {
    /**
     * 
     * @type {string}
     * @memberof FunctionalScopeResource
     */
    label: string;
    /**
     * 
     * @type {Array<FunctionalSkillResource>}
     * @memberof FunctionalScopeResource
     */
    functionalSkills: Array<FunctionalSkillResource>;
}

/**
 * Check if a given object implements the FunctionalScopeResource interface.
 */
export function instanceOfFunctionalScopeResource(value: object): value is FunctionalScopeResource {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('functionalSkills' in value) || value['functionalSkills'] === undefined) return false;
    return true;
}

export function FunctionalScopeResourceFromJSON(json: any): FunctionalScopeResource {
    return FunctionalScopeResourceFromJSONTyped(json, false);
}

export function FunctionalScopeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalScopeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'functionalSkills': ((json['functionalSkills'] as Array<any>).map(FunctionalSkillResourceFromJSON)),
    };
}

export function FunctionalScopeResourceToJSON(value?: FunctionalScopeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'functionalSkills': ((value['functionalSkills'] as Array<any>).map((v) => FunctionalSkillResourceToJSON(v))),
    };
}

